import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Tooltip, Orientation } from '@dojo/widgets/tooltip';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { FloatingActionButton } from '@dojo/widgets/floating-action-button';
import { Icon } from '@holmescorp/base-widgets';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/dashbutton.m.css';
const icache = createICacheMiddleware();
const factory = create({
    icache,
    nls: createNlsMiddleware('ditabook'),
    theme
});
export const DashButton = factory(({ middleware: { icache, nls, theme } }) => {
    const { isPlaceholder, messages: { dashboard_button_tooltip = '[ditabook] dashboard_button_tooltip' } } = nls();
    if (isPlaceholder) {
        return null;
    }
    const ttActive = () => icache.set('ttopen', true);
    const ttHidden = () => icache.set('ttopen', false);
    const altText = dashboard_button_tooltip;
    const ttText = dashboard_button_tooltip;
    const faname = 'tachometer-alt';
    const xqa = 'dash-button';
    const { root } = theme.classes(css);
    return v('div', { xqa, classes: [theme.variant(), root] }, [
        w(Tooltip, { open: icache.getOrSet('ttopen', false), orientation: Orientation.top }, [
            {
                content: ttText,
                trigger: w(FloatingActionButton, {
                    size: 'normal',
                    onClick: () => {
                        publish('open/dashboard');
                    },
                    onOver: ttActive,
                    onOut: ttHidden,
                    onFocus: ttActive,
                    onBlur: ttHidden
                }, [
                    w(Icon, {
                        size: '3x',
                        faname,
                        altText,
                        xqa
                    })
                ])
            }
        ])
    ]);
});
export default DashButton;
